<template>
  <popup
    :opened="dataToShow"
    @close="close"
  >
    <!-- BEGIN Display Content File -->
    <img
      v-if="file.filename"
      :src="'/portfolio/'+infosPass.id_pass+'/'+file.filename" 
      class="object-contain w-full h-screen rounded-md"
      alt=""
    >
    <!-- END Display Content File -->
  </popup>
</template>

<script>
import ClickOutside from 'vue-click-outside';
import { mapGetters } from 'vuex';

import Icon from './../Icon';
import Constants from './../../constants';
import Popup from './../Popup.vue';

export default {
  components:{
    Icon,
    Popup,
  },

  props:{
    file:{
      type: Object,
      required:true,
    },
    dataToShow: Boolean,
  },

  data(){
    return {
      constants: Constants,

    };
  },

  methods:{
    close(){
      this.$emit('close');
    },
  },

  computed:{
    ...mapGetters({
      infosPass: 'neopass/infosPass',
    }),
  },

  directives: {
    ClickOutside
  }
};
</script>
